import { render, staticRenderFns } from "./scroll-pane.vue?vue&type=template&id=b9d01304&scoped=true"
import script from "./scroll-pane.vue?vue&type=script&lang=js"
export * from "./scroll-pane.vue?vue&type=script&lang=js"
import style0 from "./scroll-pane.vue?vue&type=style&index=0&id=b9d01304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d01304",
  null
  
)

export default component.exports